module.exports = __webpack_public_path__ + "static/0005-0aff7097b50e22593b9fdcd84ab1da29.png";